import { FormattedMessage } from 'react-intl';

import ActionBox from 'src/features/parkingActions/components/ActionBox';
import { actionMessages } from 'src/features/parkingActions/utils/messages';
import { PointActionType } from 'src/features/points/types';
import {
    SectionBlock,
    SectionBlockHeader,
    SectionBlockHead,
    SectionBlockTitle,
    SectionBlockSeparator,
    SectionBlockBody,
} from 'src/registry/components/blocks/SectionBlock';
import { cn } from 'src/utils';

import type { Action } from 'src/features/parkingActions/routes/AllActions';

interface DashboardWidgetActionsProps extends React.HTMLAttributes<HTMLDivElement> {
    actions?: Action[];
}
const DashboardWidgetActions = ({ className, actions = [], ...props }: DashboardWidgetActionsProps) => {
    return (
        <SectionBlock className="flex-1 shrink-0">
            <SectionBlockHeader>
                <SectionBlockHead>
                    <SectionBlockTitle>
                        <FormattedMessage {...actionMessages.actions} />
                    </SectionBlockTitle>
                </SectionBlockHead>
            </SectionBlockHeader>
            <SectionBlockSeparator />
            <SectionBlockBody className={cn('grid h-full gap-4', className)} {...props}>
                {actions.map((action, index) => {
                    return (
                        <ActionBox
                            key={`action-box-home-${index}`}
                            action={action}
                            variant={
                                action.actionType == PointActionType.EMERGENCY ? 'destructiveLight' : 'outline-solid'
                            }
                        />
                    );
                })}
            </SectionBlockBody>
        </SectionBlock>
    );
};

export { DashboardWidgetActions };
